import React from "react"
import { useTranslation } from "react-i18next"

const Intro = () => {
  const { t } = useTranslation()

  return (
    <div className="px-4 py-8 bg-blue-100">
      <h2 className="text-xl md:text-2xl font-semibold mb-4">
        {t("intro-title")}
      </h2>
      <p className="text-lg">{t("intro-description")}</p>
    </div>
  )
}

export default Intro
